module.exports = __webpack_public_path__ + "static/img/04.70e0286.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/03/04.jpg
// module id = X+vZ
// module chunks = 0